import * as React from "react";
import Typography from "@mui/material/Typography";
import Timeline from '@mui/lab/Timeline';
import TimelineItem, { timelineItemClasses } from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineDot from '@mui/lab/TimelineDot';

import { BsPlusLg } from 'react-icons/bs'
import { Menu } from "@mui/material";
import { useSelector } from "react-redux";
import { useAddCustomerJourneyMutation, useUpdateCustomerJourneyMutation } from "../../../Service/CustomerJourney";
import { specialChractorValidation } from "./Utils/validation";
import { FaPen } from "react-icons/fa";
import { useAddIVFJourneyHistoryMutation, useAddIVFJourneyMutation, useGetIVFJourneymasterQuery, useGetIVFJourneysQuery } from "../../../Service/ivfJourneyStage";


export default function IvfJourney(props) {
  const { callBackforErrorMessage, openSnackBar,currentStage,refetch,refetchcurrentstage,journeys,id } = props
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [filteredItems, setFilteredItems] = React.useState(null);
  const CustomerDetail = useSelector((state: any) => state.customer.customerDetail);
  const CustomerJourneyTypes = useSelector((state: any) => state.dashboard.customerJourney);
  const [addIvfJourney] = useAddIVFJourneyHistoryMutation();
  const view = window.location.pathname.split("/")[2] ==="customerview" ;

  const open = Boolean(anchorEl);
  const [pagination, setpagination] = React.useState(1);
  const [searchValue, setSearchValue] = React.useState("");
// console.log(CustomerDetail);
const Contact = useSelector((state: any) => state.customer.customerContact);

// console.log(CustomerJourneyTypes);
function getRandomLightColor() {
  // Generate random values for red, green, and blue components
  const red = Math.floor(Math.random() * 110) + 130; // Range: 100-250
  const green = Math.floor(Math.random() * 110) + 130; // Range: 100-250
  const blue = Math.floor(Math.random() * 110) + 130; // Range: 100-250

  // Convert RGB components to hexadecimal format
  const color = (red * 65536 + green * 256 + blue).toString(16);

  // Ensure the color string has 6 digits by padding with zeros if necessary
  return '#' + '0'.repeat(6 - color.length) + color;
}
  const pagi = {
    pageNo: pagination,
    name: searchValue,
  };

// console.log("journeys",journeys);
  const transformedData = [];

for (let i = 0; i < journeys?.data.length; i++) {
  const stage = journeys?.data[i];
  if (stage.steps) {
    for (let j = 0; j < stage.steps.length; j++) {
      const step = stage.steps[j];
      transformedData.push({
        "id": step.id,
        "stepid": step.id.toString(),
        "stageid": stage.id.toString(),
        "name":  `${stage.journeyStageName}-${step.stepName}`,
        "stagename":stage.journeyStageName,
        "stepname":step.stepName,
        "stepStatus":step.stepcompletedStatus,
        "description": stage.description,
        "others": getRandomLightColor(), // Assigning a random color
        "mode": "ivf_journey",
        "status": "1",
        "comments": null,
        "createdBy": null,
        "updatedBy": null,
        "createdAt": "2024-01-09T13:01:48.000Z",
        "updatedAt": "2024-01-09T13:01:48.000Z"
      });
    }
  }
}

console.log("result",transformedData);



  function filterByValue(array, string) {
      // console.log(array);
      
    return array.filter(o => o.name.toLowerCase().includes(string.toLowerCase()));
  }

  const onChangeText = (text) => {
    if (text.trim().length === 0) {
      setFilteredItems(null)
    }
    else {
      setFilteredItems(filterByValue(transformedData, text))
    }
  }

  const handleItemClick = async(item) => {
    if (CustomerDetail.customerName.trim().length && !specialChractorValidation(CustomerDetail.customerName)) {
      if (CustomerDetail.id && Contact?.phone1) {
        try{
        // console.log("customerId",CustomerDetail.id);
        // console.logg("stagesName",item.stagename);
        // console.log("stepsName",item.stepname);
        // console.log("stagesId",item.stageid);
        // console.log("stepsId",item.stepid);
        // console.log("description",item.description);

        const payload = await addIvfJourney({
          "customerId": CustomerDetail.id,
          "stagesName": item.stagename,
          "stepsName": item.stepname,
          "stagesId": item.stageid,
          "stepsId": item.stepid,
          "description": item.description,


        }).unwrap();
        openSnackBar("Added succesfully");
      // console.log("satus",payload);
        refetch();
        refetchcurrentstage();
      }
      catch(err:any){
      // console.log("errrrrr",err);
        openSnackBar(err.data.error,"error");

        
      }

      }
      else {
        if(!Contact?.phone1){
        openSnackBar("Please add phone number","error");
      }


      }
    }
    else {
      openSnackBar(callBackforErrorMessage(), "error")
    }
    setAnchorEl(null);
  }

  return (
    <>
      <div className="mb-2">
        <span className="title">Treatment Journey *</span>
        {!view &&(  <button
          id="btn-blue"
          onClick={(e) => setAnchorEl(e.currentTarget)}
          disabled={view}
        >
<FaPen />        </button>)}
      </div>
      <div>      <span className="text-start ivf-current">Current Stage</span>
</div>{currentStage && <div><div className="current-stage">{currentStage.stagesName}-{currentStage.stepsName}</div></div>}

      {/* <Timeline sx={{
        [`& .${timelineItemClasses.root}:before`]: {
          flex: 0,
          padding: 0,
        },
      }}>
        {CustomerJourney.map((item, index) => (
          <TimelineItem key={index}>
            <TimelineSeparator>
              <TimelineDot color={index === 0 ? "success" : "primary"} />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <Typography variant="subtitle1">
                {item?.customerJourneyOption}
              </Typography>
              <Typography variant="caption">{new Date(item?.createdAt).toLocaleDateString('en-GB', {
                day: 'numeric', month: 'short', year: 'numeric'
              })}</Typography>
            </TimelineContent>
          </TimelineItem>
        ))}


      </Timeline> */}

      <Menu
        id="fade-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        style={{ padding: '10px' }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <input
          type="text"
          className="text-custom-tag"
          placeholder="Search for an option"
          style={{ width: "95%" }}
          onChange={(e) => onChangeText(e.target.value)}
        />
        <ul className="tag-ul">
          {/* <li><small>Select an option or create one</small></li> */}
          {filteredItems ? filteredItems.map((item, i) => (
            <li key={i}
            onClick={() => { if (item.stepStatus === 0){ handleItemClick(item); console.log("hi");}
             }}
            >
              <img
                src={require("../../../assets/DigitalMarketing/image/customer/tag.png")}
                width="8"
              />
              &nbsp;
              <span style={{ background: item.stepStatus === 0?item.others:"#f0f0f0" }} className={item.stepStatus === 0?`tile-tag Thyroid cursor ${item.name.split(" ")[0]}`:`tile-tag Thyroid context-menu ${item.name.split(" ")[0]}`}>
                {item.name}
              </span>

            </li>
          ))
            :
            transformedData.map((item, i) => (
              <li key={i}
              onClick={() => { if (item.stepStatus === 0){ handleItemClick(item); console.log("hi");}
            }}
              >
                <img
                  src={require("../../../assets/DigitalMarketing/image/customer/tag.png")}
                  width="8"
                />
                &nbsp;
                <span style={{ background: item.stepStatus === 0?item.others:"#f0f0f0" }} className={item.stepStatus === 0?`tile-tag Thyroid cursor ${item.name.split(" ")[0]}`:`tile-tag Thyroid context-menu ${item.name.split(" ")[0]}`}>
                  {item.name}
                </span>

              </li>
            ))
          }
        </ul>
      </Menu>
    </>
  );
}
